module.exports = __webpack_public_path__ + "static/media/undraw_dev_focus_b9xo.967fcf0f.svg";